export default __webpack_public_path__ + "static/media/pexels-saturnus99-11213541.e184534f.jpg";